import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

export default function TimelineChart({ stats, onSelectYear, activeYear }) {
  const data = useMemo(() => {
    if (!stats?.by_year) return [];
    return stats.by_year.map((y) => ({ year: y.label, count: y.count }));
  }, [stats]);

  if (!data.length) return null;
  const max = Math.max(...data.map((d) => d.count));

  return (
    <div
      data-testid="timeline-chart"
      className="border border-zinc-800 bg-zinc-950 p-4 h-[200px] flex flex-col"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
          ◆ Incident Frequency · By Year
        </span>
        {activeYear && (
          <button
            data-testid="clear-year-filter"
            onClick={() => onSelectYear?.(null)}
            className="font-mono text-[10px] uppercase tracking-widest text-amber-400 hover:text-amber-300"
          >
            Year: {activeYear} ✕
          </button>
        )}
      </div>
      <div className="flex-1 min-h-0">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
            <XAxis
              dataKey="year"
              stroke="#52525b"
              tick={{ fill: "#71717a", fontSize: 10 }}
              tickLine={false}
              axisLine={{ stroke: "#27272a" }}
            />
            <YAxis
              stroke="#52525b"
              tick={{ fill: "#71717a", fontSize: 10 }}
              tickLine={false}
              axisLine={{ stroke: "#27272a" }}
              allowDecimals={false}
            />
            <Tooltip
              contentStyle={{
                background: "#09090b",
                border: "1px solid #27272a",
                fontFamily: "JetBrains Mono, monospace",
                fontSize: 11,
                color: "#fafafa",
              }}
              cursor={{ fill: "rgba(251,191,36,0.08)" }}
            />
            <Bar
              dataKey="count"
              onClick={(d) => onSelectYear?.(parseInt(d.year))}
              cursor="pointer"
            >
              {data.map((d, i) => {
                const isPeak = d.count === max;
                const isActive = String(activeYear) === String(d.year);
                return (
                  <Cell
                    key={i}
                    fill={isActive ? "#fbbf24" : isPeak ? "#f59e0b" : "#3f3f46"}
                  />
                );
              })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
